export const routes = (prefix) => [
    {
        path: `/${prefix}/organizations/benefit-packages`,
        name: `${prefix}.organizations.benefit-packages.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.organizations.benefit-packages.index`,
                PageDescription: "Organization: benefit packages list/create",
            },
        },
    },
]